import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { axInst } from "../../../Components/Login/Service";
import { useSelector } from "react-redux";
import WaterMark from "../../../Components/WaterMark/WaterMark";
import { CylinderProgress } from "../../../Components/KPI/CylinderProgressBarCustom";

const coveragePlanApi = async (body) => {
  try {
    const res = await axInst.post(
      "dealer-sales-success-centre/coverage_plan_data",
      body
    );
    return res.data;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch coverage plan data");
  }
};

const CoveragePlan = () => {
  const { data, submitted } = useSelector((e) => e.filtersSalesSuccessCenter);

  const {
    data: coveragePlanData,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["coveragePlan", submitted],
    queryFn: () => coveragePlanApi(data),
    cacheTime: 0,
    staleTime: 0,
  });

  const yesterdayPlan = coveragePlanData?.["Yesterday's_Plan"];
  const mtdPlan = coveragePlanData?.["MTD_Till_Yesterday's_Plan"];

  return (
    <div className="relative h-full">
      {isFetching && (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      )}
      {isError && (
        <div className="grid items-center justify-center w-full h-full">
          <p>Error Occurred</p>
        </div>
      )}
      <WaterMark />
      {!isFetching && !isError && (
        <div className="p-2 bg-white rounded-xl shadow w-full h-full">
          <h2 className="pb-2 text-base font-semibold text-[#4c4c4c]">
            Coverage Plan
          </h2>

          <h3 className="text-sm font-semibold text-[#34495E] pb-1 border-b border-gray-300 mb-1">
            Yesterday’s Plan
          </h3>
          <CylinderProgress
            label="BTL Activity"
            value={yesterdayPlan?.BTL_Activity?.ACTUAL ?? 0}
            target={yesterdayPlan?.BTL_Activity?.TARGET ?? 0}
            actualTitle="Actual"
            targetTitle="Target"
          />

          <h3 className="text-sm font-semibold text-[#34495E] pb-1 border-b border-gray-300 mb-1">
            MTD Yesterday's Plan
          </h3>
          <CylinderProgress
            label="Beat Plan Customer Visit"
            value={mtdPlan?.Beat_Plan_Customer_Visit?.ACTUAL ?? 0}
            target={mtdPlan?.Beat_Plan_Customer_Visit?.TARGET ?? 0}
            actualTitle="Actual Visits Done"
            targetTitle="Customer  Planned Visits"
          />
          <CylinderProgress
            label="BTL Activity"
            value={mtdPlan?.BTL_Activity?.ACTUAL ?? 0}
            target={mtdPlan?.BTL_Activity?.TARGET ?? 0}
            actualTitle="Actual"
            targetTitle="Target"
          />
          <CylinderProgress
            label="PVIN-Adherance"
            value={mtdPlan?.PVIN_Adherence?.ACTUAL ?? 0}
            target={mtdPlan?.PVIN_Adherence?.TARGET ?? 0}
            actualTitle="PVIN Planned"
            targetTitle="PVIN Adherence"
          />
        </div>
      )}
    </div>
  );
};

export default CoveragePlan;
